import React from 'react';
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {GameCenterIndexPageController} from "../game-center.index-page.controller";
import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {GameCenterWidgetAsync} from "../../../../../widgets/game-center-widget/components/game-center-widget.async";
import {useLocation, useOutletContext} from "react-router-dom";

export class GameCenterIndexPageComponentProps extends BaseModuleProps {}

export const GameCenterIndexPageComponent = ({controller}: GameCenterIndexPageComponentProps) => {
  const location: Location = useLocation();
  const {scrollToTop} = useOutletContext();
  const {state: {gameId}} = controller;

  const gameCenterWidgetProps = {
    location,
    gameId,
    scrollToTop: () => scrollToTop?.(),
  }

  return <GameCenterWidgetAsync {...gameCenterWidgetProps}/>
};

const settings: ComposeSettings = {
  component: GameCenterIndexPageComponent,
  propsType: GameCenterIndexPageComponentProps,
  controllerType: GameCenterIndexPageController,

  observe: true,
  createModule: true,
  useMetadata: true,
};

export const GameCenterIndexPage = Compose(settings);

export default GameCenterIndexPage;
